import {
    FrontEndConfigFormField,
    FrontEndConfigFormModel,
} from 'app/overview/config/configuration_tab/general/frontend_config/FrontEndConfigFormModel';
import { SingleValueFormFieldModel } from 'app/overview/config/configuration_tab/general/frontend_config/AbstractSingleValueFormFieldModel';

export class NumberFormFieldModel extends SingleValueFormFieldModel<number> {
    private readonly _required: boolean;
    /**
     *
     * @param {FrontEndConfigFormModel} frontEndConfigFormModel
     * @param {FrontEndConfigFormField} formField
     * @param {boolean} required if required, an empty string will bring up a warning
     */
    constructor(
        frontEndConfigFormModel: FrontEndConfigFormModel,
        formField: FrontEndConfigFormField,
        required = true,
    ) {
        super(frontEndConfigFormModel, formField);
        this._required = required;
    }

    setValue(newValue: number) {
        if (isNaN(newValue)) {
            this._valueUnderEdit = null;
            this._notifyListeners();
        } else {
            this._valueUnderEdit = newValue;
            this._notifyListeners();
        }
    }

    isValid() {
        return this._required && this._valueUnderEdit !== null;
    }
}
